<template>
  <div
    class="c-rect-create"
    @click="rectCreate()"
  >
    <slot />
  </div>
</template>

<script>
import { ClassRectComputed } from '@/helpers/rect'
import { getMaxValueOfArray } from '@/helpers/base'
import { config_rect } from '@/config'
export default {
  name: 'c-rect-create',
  props: {
    selector_wrap: {
      type: String,
      default: '.c-rect-wrapper'
    }
  },
  computed: {
    rect_list() {
      return this.$store.getters.RECT_LIST
    },
    rect_count() {
      return this.rect_list.length
    },
    rect_options() {
      return this.$store.getters.RECT_OPTIONS
    }
  },
  methods: {
    /* Хэлперы */
    updateZIndex() {
      let index_list = this.rect_list.map(i => i.z_index)
      let max_index = getMaxValueOfArray(index_list)
      return Number.isInteger(max_index) ? max_index + 1 : 1
    },
    /* Хэлперы */

    createObjByRect(rect_id) {
      const utils = new ClassRectComputed(this.selector_wrap, this.rect_options)
      const { width, height } = config_rect
      return {
        rect_id,
        draggable: false,
        resizable: false,
        z_index: this.updateZIndex(),
        ...utils.size(),
        ...utils.position(width, height)
      }
    },
    createObjByMap(rect_id) {
      return {
        rect_id,
        zoom: 11,
        center: [48.465, 35.05]
      }
    },

    rectCreate() {
      const rect_id = Date.now()

      if(this.rect_count < config_rect.max_count) {
        this.$store.commit('RECT_ADD', {
          ...this.createObjByRect(rect_id)
        })
        this.$store.commit('RECT_MAP_OPTIONS_ADD', {
          ...this.createObjByMap(rect_id)
        })
      }
    },
  }
}
</script>